import { ReactNode } from "react";
import { Separator } from "@/app/modules/User/components/Separator.tsx";

export const Section = ({
  heading,
  children,
  hideSeparator,
}: {
  heading: string;
  children: ReactNode[] | ReactNode;
  hideSeparator?: boolean;
}) => {
  return (
    <div className="flex w-full flex-col justify-start">
      <div className="p2-bold pb-[20px] text-item-secondary">{heading}</div>
      <div className="p1-regular flex flex-col gap-8">{children}</div>
      {!hideSeparator && <Separator />}
    </div>
  );
};
